import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userName, setUserName] = useState('');
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Check login status
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    const name = localStorage.getItem('userName') || '';
    setIsLoggedIn(loggedIn);
    setUserName(name);
  }, []);

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  const handleLogout = () => {
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    setIsLoggedIn(false);
    setUserName('');
    setShowUserMenu(false);
    navigate('/');
  };

  return (
    <header id="main-header" className="bg-white shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <a href="/" onClick={(e) => { e.preventDefault(); handleNavigation('/'); }} className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/50f4002bde5ecf02750e3107d0496ef3/ea8d57dd3e7415a4fbb16dc09a9dc337.jpeg" 
                alt="LedgRkeepR" 
                className="h-16 w-auto"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex lg:items-center lg:space-x-8">
                <div className="relative group">
                  <button className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200 flex items-center">
                    Services
                    <i className="ri-arrow-down-s-line ml-1"></i>
                  </button>
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-2">
                      <a href="/bookkeeping" onClick={(e) => { e.preventDefault(); handleNavigation('/bookkeeping'); }} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
                        <div className="font-medium">Bookkeeping</div>
                        <div className="text-sm text-gray-500">Complete financial record management</div>
                      </a>
                      <a href="/medical-billing" onClick={(e) => { e.preventDefault(); handleNavigation('/medical-billing'); }} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
                        <div className="font-medium">Medical Billing</div>
                        <div className="text-sm text-gray-500">HIPAA-compliant healthcare billing</div>
                      </a>
                      <a href="/tax-planning" onClick={(e) => { e.preventDefault(); handleNavigation('/tax-planning'); }} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
                        <div className="font-medium">Tax Planning</div>
                        <div className="text-sm text-gray-500">Strategic tax optimization</div>
                      </a>
                      <a href="/financial-consulting" onClick={(e) => { e.preventDefault(); handleNavigation('/financial-consulting'); }} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
                        <div className="font-medium">Financial Consulting</div>
                        <div className="text-sm text-gray-500">Expert financial guidance</div>
                      </a>
                      <a href="/cost-accounting" onClick={(e) => { e.preventDefault(); handleNavigation('/cost-accounting'); }} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
                        <div className="font-medium">Cost Accounting</div>
                        <div className="text-sm text-gray-500">Detailed cost analysis</div>
                      </a>
                      <a href="/audit-support" onClick={(e) => { e.preventDefault(); handleNavigation('/audit-support'); }} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
                        <div className="font-medium">Audit Support</div>
                        <div className="text-sm text-gray-500">Professional audit assistance</div>
                      </a>
                    </div>
                  </div>
                </div>
                <div className="relative group">
                  <button className="text-gray-700 hover:text-green-600 font-medium transition-colors duration-200 flex items-center">
                    Industries
                    <i className="ri-arrow-down-s-line ml-1"></i>
                  </button>
                  <div className="absolute top-full left-0 mt-2 w-64 bg-white rounded-lg shadow-xl border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
                    <div className="py-2">
                      <a href="/healthcare" onClick={(e) => { e.preventDefault(); handleNavigation('/healthcare'); }} className="block px-4 py-3 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200">
                        <div className="font-medium">Healthcare</div>
                        <div className="text-sm text-gray-500">Medical practices & clinics</div>
                      </a>
                      <a href="/wellness-beauty" onClick={(e) => { e.preventDefault(); handleNavigation('/wellness-beauty'); }} className="block px-4 py-3 text-gray-700 hover:bg-pink-50 hover:text-pink-600 transition-colors duration-200">
                        <div className="font-medium">Wellness & Beauty</div>
                        <div className="text-sm text-gray-500">Salons & spas</div>
                      </a>
                      <a href="/construction" onClick={(e) => { e.preventDefault(); handleNavigation('/construction'); }} className="block px-4 py-3 text-gray-700 hover:bg-orange-50 hover:text-orange-600 transition-colors duration-200">
                        <div className="font-medium">Construction</div>
                        <div className="text-sm text-gray-500">Contractors & builders</div>
                      </a>
                      <a href="/retail" onClick={(e) => { e.preventDefault(); handleNavigation('/retail'); }} className="block px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors duration-200">
                        <div className="font-medium">Retail</div>
                        <div className="text-sm text-gray-500">Stores & e-commerce</div>
                      </a>
                      <a href="/restaurants" onClick={(e) => { e.preventDefault(); handleNavigation('/restaurants'); }} className="block px-4 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors duration-200">
                        <div className="font-medium">Restaurants</div>
                        <div className="text-sm text-gray-500">Food service businesses</div>
                      </a>
                      <a href="/professional-services" onClick={(e) => { e.preventDefault(); handleNavigation('/professional-services'); }} className="block px-4 py-3 text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 transition-colors duration-200">
                        <div className="font-medium">Professional Services</div>
                        <div className="text-sm text-gray-500">Consultants & agencies</div>
                      </a>
                      <a href="/real-estate" onClick={(e) => { e.preventDefault(); handleNavigation('/real-estate'); }} className="block px-4 py-3 text-gray-700 hover:bg-teal-50 hover:text-teal-600 transition-colors duration-200">
                        <div className="font-medium">Real Estate</div>
                        <div className="text-sm text-gray-500">Agents & property management</div>
                      </a>
                    </div>
                  </div>
                </div>
                <a href="/pricing" onClick={(e) => { e.preventDefault(); handleNavigation('/pricing'); }} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
                  Pricing
                </a>
                <a href="/about" onClick={(e) => { e.preventDefault(); handleNavigation('/about'); }} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
                  About
                </a>
                <a href="/downloads" onClick={(e) => { e.preventDefault(); handleNavigation('/downloads'); }} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
                  Downloads
                </a>
                <a href="/contact" onClick={(e) => { e.preventDefault(); handleNavigation('/contact'); }} className="text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200">
                  Contact
                </a>
                <LanguageSwitcher />
              </div>

          {/* User Menu / Login Button */}
          <div className="hidden md:flex items-center space-x-4">
            {isLoggedIn ? (
              <div className="relative">
                <button
                  onClick={() => setShowUserMenu(!showUserMenu)}
                  className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 transition-colors duration-200 cursor-pointer"
                >
                  <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center">
                    <span className="text-white text-sm font-medium">
                      {userName.charAt(0).toUpperCase()}
                    </span>
                  </div>
                  <span className="font-medium">{userName}</span>
                  <i className="ri-arrow-down-s-line"></i>
                </button>

                {showUserMenu && (
                  <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-xl border border-gray-200 z-50">
                    <div className="py-2">
                      <a
                        href="/dashboard"
                        onClick={(e) => { e.preventDefault(); handleNavigation('/dashboard'); setShowUserMenu(false); }}
                        className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200"
                      >
                        <i className="ri-dashboard-line mr-2"></i>
                        Dashboard
                      </a>
                      <a
                        href="/profile"
                        onClick={(e) => { e.preventDefault(); handleNavigation('/profile'); setShowUserMenu(false); }}
                        className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600 transition-colors duration-200"
                      >
                        <i className="ri-user-line mr-2"></i>
                        Profile
                      </a>
                      <div className="border-t border-gray-200 my-1"></div>
                      <button
                        onClick={handleLogout}
                        className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-red-50 hover:text-red-600 transition-colors duration-200"
                      >
                        <i className="ri-logout-box-line mr-2"></i>
                        Logout
                      </button>
                    </div>
                  </div>
                )}
              </div>
            ) : (
              <div className="flex items-center space-x-3">
                <button
                  onClick={() => handleNavigation('/login')}
                  className="flex items-center space-x-2 text-gray-700 hover:text-blue-600 font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-user-line text-lg"></i>
                  </div>
                  <span>Sign In</span>
                </button>
                <button
                  onClick={() => handleNavigation('/register')}
                  className="whitespace-nowrap cursor-pointer font-medium rounded-lg transition-all duration-200 inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl px-6 py-3 text-base"
                >
                  Get Started
                </button>
              </div>
            )}
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center space-x-4">
            <LanguageSwitcher />
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-gray-500 hover:text-gray-600 focus:outline-none focus:text-gray-600 cursor-pointer"
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-gray-200">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <a href="/" onClick={(e) => { e.preventDefault(); handleNavigation('/'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Home
              </a>
              <a href="/about" onClick={(e) => { e.preventDefault(); handleNavigation('/about'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                About
              </a>
              <a href="/bookkeeping" onClick={(e) => { e.preventDefault(); handleNavigation('/bookkeeping'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Bookkeeping Services
              </a>
              <a href="/medical-billing" onClick={(e) => { e.preventDefault(); handleNavigation('/medical-billing'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Medical Billing
              </a>
              <a href="/tax-planning" onClick={(e) => { e.preventDefault(); handleNavigation('/tax-planning'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Tax Planning
              </a>
              <a href="/financial-consulting" onClick={(e) => { e.preventDefault(); handleNavigation('/financial-consulting'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Financial Consulting
              </a>
              <a href="/audit-support" onClick={(e) => { e.preventDefault(); handleNavigation('/audit-support'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Audit Support
              </a>
              <a href="/cost-accounting" onClick={(e) => { e.preventDefault(); handleNavigation('/cost-accounting'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Cost Accounting
              </a>
              <div className="border-t border-gray-200 my-2"></div>
              <div className="px-3 py-2 text-sm font-medium text-gray-500">Industries</div>
              <a href="/healthcare" onClick={(e) => { e.preventDefault(); handleNavigation('/healthcare'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Healthcare
              </a>
              <a href="/wellness-beauty" onClick={(e) => { e.preventDefault(); handleNavigation('/wellness-beauty'); }} className="block px-3 py-2 text-gray-700 hover:text-pink-600 transition-colors cursor-pointer">
                Wellness & Beauty
              </a>
              <a href="/construction" onClick={(e) => { e.preventDefault(); handleNavigation('/construction'); }} className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer">
                Construction
              </a>
              <a href="/retail" onClick={(e) => { e.preventDefault(); handleNavigation('/retail'); }} className="block px-3 py-2 text-gray-700 hover:text-purple-600 transition-colors cursor-pointer">
                Retail
              </a>
              <a href="/restaurants" onClick={(e) => { e.preventDefault(); handleNavigation('/restaurants'); }} className="block px-3 py-2 text-gray-700 hover:text-red-600 transition-colors cursor-pointer">
                Restaurants
              </a>
              <a href="/professional-services" onClick={(e) => { e.preventDefault(); handleNavigation('/professional-services'); }} className="block px-3 py-2 text-gray-700 hover:text-indigo-600 transition-colors cursor-pointer">
                Professional Services
              </a>
              <a href="/real-estate" onClick={(e) => { e.preventDefault(); handleNavigation('/real-estate'); }} className="block px-3 py-2 text-gray-700 hover:text-teal-600 transition-colors cursor-pointer">
                Real Estate
              </a>
              <div className="border-t border-gray-200 my-2"></div>
              <a href="/downloads" onClick={(e) => { e.preventDefault(); handleNavigation('/downloads'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Downloads
              </a>
              <a href="/contact" onClick={(e) => { e.preventDefault(); handleNavigation('/contact'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                Contact
              </a>
              
              {/* Mobile Login/User Menu */}
              <div className="border-t border-gray-200 my-2"></div>
              {isLoggedIn ? (
                <>
                  <div className="px-3 py-2 text-sm font-medium text-gray-500">Account</div>
                  <a href="/dashboard" onClick={(e) => { e.preventDefault(); handleNavigation('/dashboard'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                    Dashboard
                  </a>
                  <a href="/profile" onClick={(e) => { e.preventDefault(); handleNavigation('/profile'); }} className="block px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                    Profile
                  </a>
                  <button
                    onClick={handleLogout}
                    className="block w-full text-left px-3 py-2 text-gray-700 hover:text-red-600 transition-colors cursor-pointer"
                  >
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <a href="/login" onClick={(e) => { e.preventDefault(); handleNavigation('/login'); }} className="flex items-center space-x-2 px-3 py-2 text-gray-700 hover:text-blue-600 transition-colors cursor-pointer">
                    <i className="ri-user-line"></i>
                    <span>Sign In</span>
                  </a>
                  <button
                    onClick={() => handleNavigation('/register')}
                    className="w-full mt-4 whitespace-nowrap cursor-pointer font-medium rounded-lg transition-all duration-200 inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white shadow-lg hover:shadow-xl px-6 py-3 text-base"
                  >
                    Get Started
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
